import * as ActionTypes from '../action-types'

const notifications_DefaultState = []

export const notifications = (state = notifications_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_NOTIFICATION_THRU_WS: {
            const notification = action.notification

            if(typeof notification === 'object' && notification !== null) {
                newState = [ ...newState, notification ]
            }

            return newState            
        }
        case ActionTypes.CLEAR_NOTIFICATIONS: {
            newState = []

            return newState
        }
        default: {
            return newState;
        }
    }
}